import { useTranslation } from 'react-i18next';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';

export default function Marquee() {
  const { t, i18n } = useTranslation();
  const items = t('marquee', { returnObjects: true }) || [];
  const isAr = i18n.language === 'ar';

  // ONE single set of words — no duplication ever.
  const loop = items;

  // Scroll-driven marquee: nothing animates unless the visitor scrolls.
  // As the section moves through the viewport, the strip sweeps across.
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start'],
  });
  const x = useTransform(
    scrollYProgress,
    [0, 1],
    isAr ? ['-90%', '90%'] : ['90%', '-90%']
  );
  const opacity = useTransform(scrollYProgress, [0, 0.15, 0.85, 1], [0, 1, 1, 0]);

  return (
    <section
      ref={sectionRef}
      data-testid="marquee-section"
      className="relative py-14 md:py-24 overflow-hidden bg-white border-y border-[#10092E]/8"
      aria-hidden="true"
    >
      <motion.div
        style={{ x, opacity }}
        className="dwk-marquee gap-16 md:gap-24 whitespace-nowrap"
      >
        {loop.map((w, i) => (
          <div key={i} className="flex items-center gap-16 md:gap-24">
            <span
              className={`text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight text-[#10092E] ${isAr ? 'font-ar' : 'font-en'}`}
            >
              {w}
            </span>
            <span className="w-3 h-3 rounded-full dwk-gradient shrink-0" />
          </div>
        ))}
      </motion.div>
    </section>
  );
}
